import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

// TODO: Replace with real valuation result UI once combined comp engine + LightGBM
// endpoint is production-wired. Prototype reference:
// https://platex-lab-tool.pages.dev/combined/
@Component({
  selector: 'pla-sell-valuation-placeholder',
  templateUrl: './sell-valuation-placeholder.component.html',
  styleUrls: ['./sell-valuation-placeholder.component.scss'],
})
export class SellValuationPlaceholderComponent implements OnInit {
  registration: string = '';

  constructor(private route: ActivatedRoute) {}

  ngOnInit(): void {
    const raw = this.route.snapshot.paramMap.get('registration') || '';
    this.registration = decodeURIComponent(raw).toUpperCase();
  }
}
